import { Vue } from "vue-property-decorator";


export const LoggingService = new Vue({
    methods: {
        log(...data: any[]) {
            this.info(data); // tslint:disable-line
        },
        debug(...data: any[]) {
            if (!process.env.VUE_APP_IRIS_LOGGING) return;
            console.debug(data); // tslint:disable-line
        },
        info(...data: any[]) {
            if (!process.env.VUE_APP_IRIS_LOGGING) return;
            console.info(data); // tslint:disable-line
        },
        warn(...data: any[]) {
            if (!process.env.VUE_APP_IRIS_LOGGING) return;
            console.warn(data); // tslint:disable-line
        },
        error(...data: any[]) {
            if (!process.env.VUE_APP_IRIS_LOGGING) return;
            console.error(data); // tslint:disable-line
        },
    },
});